/**
 * Formats milliseconds to human readable duration format.
 *
 * @example
 *   formatMillisecondsToDuration(999) -> 1s
 *
 * @example
 *   formatMillisecondsToDuration(30000) -> 0m 30s
 *
 * @example
 *   formatMillisecondsToDuration(233400) -> 3m 53s
 *
 * @example
 *   formatMillisecondsToDuration(23840020) -> 6h 37m 20s
 *
 * @example
 *   formatMillisecondsToDuration(238400200) -> 2d 18h 13m 20s
 *
 * @param milliseconds Milliseconds that should be formatted.
 */
export function formatMillisecondsToDuration(milliseconds) {
    if (milliseconds < 1000) {
        const result = (milliseconds / 1000).toFixed(0);
        return `${result}s`;
    }
    const days = milliseconds / (1000 * 60 * 60 * 24);
    const absoluteDays = Math.floor(days);
    const hours = (days - absoluteDays) * 24;
    const absoluteHours = Math.floor(hours);
    const minutes = (hours - absoluteHours) * 60;
    const absoluteMinutes = Math.floor(minutes);
    const seconds = (minutes - absoluteMinutes) * 60;
    const absoluteSeconds = Math.floor(seconds);
    let result = ``;
    absoluteDays !== 0 ? (result += `${absoluteDays}d `) : result;
    absoluteHours !== 0 ? (result += `${absoluteHours}h `) : result;
    result += `${absoluteMinutes}m `;
    result += `${absoluteSeconds}s`;
    return result;
}
